export default __webpack_public_path__ + "fb14661de19dd2f538b3903ab0f5538b.jpg";